export default __webpack_public_path__ + "img/bBFVHTtK.3e1511e9.svg";